import { useStore } from 'features/ListBuilder/infra/react/ListBuilderStore/useStore'

export const useBuildListState = () =>
  useStore(store => store.buildList.state)
